import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Quasar from 'quasar/src/vue-plugin.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  setup(__props) {

const { locale } = useI18n()

const availableLocales = [
  { value: 'uz', label: "O'zbekcha (Lotin)" },
  { value: 'uz-crl', label: 'Ўзбекча (Кирилл)' },
  { value: 'en', label: 'English' },
  { value: 'ru', label: 'Русский' }
]

const currentLocale = computed(() => locale.value)

const currentLocaleLabel = computed(() => {
  const current = availableLocales.find(l => l.value === locale.value)
  return current ? current.label : availableLocales[0].label
})

const changeLocale = async (newLocale: string) => {
  locale.value = newLocale
  localStorage.setItem('locale', newLocale)

  // Update Quasar language pack
  try {
    let langPack
    if (newLocale === 'en') {
      langPack = await import('quasar/lang/en-US')
    } else {
      // Use Russian for Uzbek locales and Russian
      langPack = await import('quasar/lang/ru')
    }
    Quasar.lang.set(langPack.default)
  } catch (err) {
    console.error('Failed to load Quasar language pack:', err)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    flat: "",
    dense: "",
    label: currentLocaleLabel.value,
    icon: "language",
    class: "language-switcher"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availableLocales, (locale) => {
            return _withDirectives(_createVNode(_component_q_item, {
              key: locale.value,
              clickable: "",
              onClick: ($event: any) => (changeLocale(locale.value)),
              active: currentLocale.value === locale.value,
              "active-class": "bg-primary text-white"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(locale.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                (currentLocale.value === locale.value)
                  ? (_openBlock(), _createBlock(_component_q_item_section, {
                      key: 0,
                      side: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "check",
                          color: "primary"
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["onClick", "active"]), [
              [_directive_close_popup]
            ])
          }), 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})